import { createSelector } from '@reduxjs/toolkit'

import { selectMultiExport } from './selectMultiExport'

export const selectMultiExportProgress = createSelector(
  selectMultiExport,
  ({ generatedReportsIds }) => ({
    completed: generatedReportsIds.filter((it) => !it.inProgress).length,
    total: generatedReportsIds.length,
  })
)
